import { render, staticRenderFns } from "./panic-detail.vue?vue&type=template&id=f165ad9c&scoped=true&"
import script from "./panic-detail.vue?vue&type=script&lang=js&"
export * from "./panic-detail.vue?vue&type=script&lang=js&"
import style0 from "./panic-detail.vue?vue&type=style&index=0&id=f165ad9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f165ad9c",
  null
  
)

export default component.exports